const errorCodes = {};

errorCodes[(errorCodes.SYSTEM = 100)] = "System";
errorCodes[(errorCodes.APPLICATION = 101)] = "Application";
errorCodes[(errorCodes.BUSINESS_RULE = 102)] = "BusinessRule";
errorCodes[(errorCodes.FIELD_VALIDATION = 103)] = "FieldValidation";

export default errorCodes;
